import type { FlagConfiguration } from '@atlassian/jira-flags';
import messages from './messages';

export const ErrorFlag = (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	description: messages.description,
	isAutoDismiss: false,
});
